/**
 * Gender classification helpers.
 */

import { AMBIGUOUS_NAMES } from './constants';
import type { Member } from '@/types/member';

export function reclassifyAmbiguousGenders(members: Member[]): Member[] {
  return members.map((r) => {
    if (r.GenderConfidence === 'manual') return r;
    const firstName = (r.Name || '').trim().split(/\s+/)[0].toLowerCase();
    if (AMBIGUOUS_NAMES.has(firstName)) {
      return { ...r, Gender: 'unknown', GenderConfidence: 'low' };
    }
    return r;
  });
}

export type GenderCounts = { male: number; female: number; unknown: number };

export function countGenders(members: Member[]): GenderCounts {
  const counts: GenderCounts = { male: 0, female: 0, unknown: 0 };
  for (const m of members) {
    const g = (m.Gender || 'unknown').toLowerCase() as keyof GenderCounts;
    if (g in counts) counts[g]++;
    else counts.unknown++;
  }
  return counts;
}
